module.exports = __webpack_public_path__ + "img/2010 winteressen 033.06ebc489.jpg";